import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_SHORT_NAME, SITE_URL } from "./siteConfig";

export const stripHtml = (value = "") =>
  String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const clampText = (value = "", maxLength = 160) => {
  const cleaned = stripHtml(value);
  if (cleaned.length <= maxLength) return cleaned;
  return `${cleaned.slice(0, maxLength - 1).trim()}…`;
};

export const buildTitle = (title) =>
  title ? `${title} | ${SITE_SHORT_NAME}` : SITE_NAME;

export const resolveAbsoluteUrl = (pathOrUrl = "/", fallback = SITE_URL) => {
  if (!pathOrUrl) return fallback;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;

  const base = String(fallback || SITE_URL).replace(/\/+$/, "");
  const path = String(pathOrUrl).startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${base}${path}`;
};

export const buildCanonicalUrl = (path) => resolveAbsoluteUrl(path || "/");

export const buildDescription = (description, fallback = "") =>
  clampText(description || fallback || "", 165);

export const normalizeKeywords = (keywords = []) =>
  Array.isArray(keywords)
    ? keywords.filter(Boolean).join(", ")
    : String(keywords || "");

export const getImageUrl = (image) => resolveAbsoluteUrl(image || DEFAULT_OG_IMAGE);
